module.exports = __webpack_public_path__ + "static/image5-5a324f1d17a684f2d0fd1171d19805e9.png";